import {
  Box,
  BoxProps,
  Stack,
  Typography
} from "@mui/material";
import { common } from "@mui/material/colors";
import {
  alpha,
  styled
} from "@mui/material/styles";
import {
  ButtonBookmark,
  ButtonLink,
  ButtonProps,
  Icon
} from "../../components";

import { ButtonDigited } from "../../components/Button/Button.variants";
import {
  StyledStatusBox
} from "../../components/StatusBox/StatusBox.component";
import { OverlayStack } from "../CtaOverlay/CtaOverlay.styles";
import { PlayerLoader } from "../PlayerLoader";
import type { PlayerLoaderProps } from "components/PlayerLoader/PlayerLoader.types";

export const StyledButtonBookmark = styled(ButtonBookmark)<
  ButtonProps & { $selected: boolean, $isFromYoutube: boolean }
>(({ $selected, $isFromYoutube, theme }) => ({
  alignItems: "center",
  border: "none",
  bottom: $isFromYoutube ? "100px" : "65px",
  cursor: "pointer",
  display: "flex",
  height: "30px",
  minWidth:"30px",
  opacity: 0,
  padding: 0,
  position: "absolute",
  right: "100px",
  transition: "all .1s ease 0s",
  zIndex: "3 !important",

  "&:before": {
    /* eslint-disable max-len */
    backgroundImage: $selected
      ? `url("data:image/svg+xml,%3Csvg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.60938 5.52266C3.60938 3.8425 3.60938 3.00242 3.93636 2.36068C4.22398 1.7962 4.68292 1.33726 5.2474 1.04964C5.88914 0.722656 6.72922 0.722656 8.40938 0.722656H20.4766C22.1567 0.722656 22.9968 0.722656 23.6385 1.04964C24.203 1.33726 24.662 1.7962 24.9496 2.36068C25.2766 3.00242 25.2766 3.8425 25.2766 5.52266V17.5898C25.2766 19.27 25.2766 20.1101 24.9496 20.7518C24.662 21.3163 24.203 21.7752 23.6385 22.0629C22.9968 22.3898 22.1567 22.3898 20.4766 22.3898H8.40938C6.72922 22.3898 5.88914 22.3898 5.2474 22.0629C4.68292 21.7752 4.22398 21.3163 3.93636 20.7518C3.60938 20.1101 3.60938 19.27 3.60938 17.5898V5.52266Z' fill='%23${theme.customColors.systemPrimary02.replace("#", "")}' opacity='0.7'/%3E%3Cpath d='M21.9618 23.0283H7.02211C4.78694 23.0283 2.98438 21.2102 2.98438 18.9882V4.05447C2.98438 2.79917 3.5612 1.63045 4.54179 0.865724C4.84462 0.620435 5.30608 0.67815 5.55122 0.995582C5.79637 1.31301 5.73869 1.7603 5.42144 2.00559C4.78694 2.49617 4.412 3.24646 4.412 4.0689V18.9882C4.412 20.4167 5.58007 21.5854 7.00769 21.5854H21.9473C23.375 21.5854 24.543 20.4167 24.543 18.9882V4.04004C24.543 3.34747 24.269 2.69817 23.7787 2.19317C23.2884 1.70259 22.6395 1.42844 21.9329 1.42844H9.25729C8.85352 1.44287 8.53627 1.12544 8.53627 0.721436C8.53627 0.317432 8.85352 0.0144287 9.25729 0.0144287H21.9618V0C23.0433 0 24.0527 0.418433 24.817 1.18316C25.5813 1.94788 25.9995 2.95789 25.9995 4.04004V18.9882C25.9995 21.2247 24.1825 23.0283 21.9618 23.0283Z' fill='%23${theme.customColors.systemPrimary02.replace("#", "")}'/%3E%3Cpath d='M22.6979 25.9995H5.77791C2.16672 25.9995 0 22.1868 0 20.0201V5.06341C0 4.58726 0.115364 4.13997 0.331672 3.72154C0.519138 3.36082 0.951753 3.23096 1.29785 3.4041C1.65836 3.59168 1.78814 4.02454 1.6151 4.37083C1.49973 4.58726 1.44205 4.81812 1.44205 5.06341L1.44448 19.4995C1.44448 20.944 2.88896 24.5552 6.50015 24.5552L22.6979 24.5278C23.1593 24.5278 23.6064 24.3402 23.938 23.9795C24.212 23.6909 24.6735 23.6765 24.9619 23.9506C25.2503 24.2248 25.2647 24.6865 24.9763 24.9751C24.3562 25.6243 23.5487 25.9706 22.6834 25.9706L22.6979 25.9995Z' fill='%23${theme.customColors.systemPrimary02.replace("#", "")}'/%3E%3C/svg%3E%0A");`
      : `url("data:image/svg+xml,%3Csvg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.60938 5.52266C3.60938 3.8425 3.60938 3.00242 3.93636 2.36068C4.22398 1.7962 4.68292 1.33726 5.2474 1.04964C5.88914 0.722656 6.72922 0.722656 8.40938 0.722656H20.4766C22.1567 0.722656 22.9968 0.722656 23.6385 1.04964C24.203 1.33726 24.662 1.7962 24.9496 2.36068C25.2766 3.00242 25.2766 3.8425 25.2766 5.52266V17.5898C25.2766 19.27 25.2766 20.1101 24.9496 20.7518C24.662 21.3163 24.203 21.7752 23.6385 22.0629C22.9968 22.3898 22.1567 22.3898 20.4766 22.3898H8.40938C6.72922 22.3898 5.88914 22.3898 5.2474 22.0629C4.68292 21.7752 4.22398 21.3163 3.93636 20.7518C3.60938 20.1101 3.60938 19.27 3.60938 17.5898V5.52266Z' fill='%23${theme.customColors.textPrimary.replace("#", "")}' opacity='0.7'/%3E%3Cpath d='M21.9618 23.0283H7.02211C4.78694 23.0283 2.98438 21.2102 2.98438 18.9882V4.05447C2.98438 2.79917 3.5612 1.63045 4.54179 0.865724C4.84462 0.620435 5.30608 0.67815 5.55122 0.995582C5.79637 1.31301 5.73869 1.7603 5.42144 2.00559C4.78694 2.49617 4.412 3.24646 4.412 4.0689V18.9882C4.412 20.4167 5.58007 21.5854 7.00769 21.5854H21.9473C23.375 21.5854 24.543 20.4167 24.543 18.9882V4.04004C24.543 3.34747 24.269 2.69817 23.7787 2.19317C23.2884 1.70259 22.6395 1.42844 21.9329 1.42844H9.25729C8.85352 1.44287 8.53627 1.12544 8.53627 0.721436C8.53627 0.317432 8.85352 0.0144287 9.25729 0.0144287H21.9618V0C23.0433 0 24.0527 0.418433 24.817 1.18316C25.5813 1.94788 25.9995 2.95789 25.9995 4.04004V18.9882C25.9995 21.2247 24.1825 23.0283 21.9618 23.0283Z' fill='%23${theme.customColors.textPrimary.replace("#", "")}'/%3E%3Cpath d='M22.6979 25.9995H5.77791C2.16672 25.9995 0 22.1868 0 20.0201V5.06341C0 4.58726 0.115364 4.13997 0.331672 3.72154C0.519138 3.36082 0.951753 3.23096 1.29785 3.4041C1.65836 3.59168 1.78814 4.02454 1.6151 4.37083C1.49973 4.58726 1.44205 4.81812 1.44205 5.06341L1.44448 19.4995C1.44448 20.944 2.88896 24.5552 6.50015 24.5552L22.6979 24.5278C23.1593 24.5278 23.6064 24.3402 23.938 23.9795C24.212 23.6909 24.6735 23.6765 24.9619 23.9506C25.2503 24.2248 25.2647 24.6865 24.9763 24.9751C24.3562 25.6243 23.5487 25.9706 22.6834 25.9706L22.6979 25.9995Z' fill='%23${theme.customColors.textPrimary.replace("#", "")}'/%3E%3C/svg%3E%0A");`,
    /* eslint-enable max-len */
    backgroundRepeat: "no-repeat",
    content: " '' !important ",
    display: "flex",
    height: "30px",
    minWidth: "25px"
  },
  "&:hover":{
    transform: "scale(1.2)",
    backgroundColor: "transparent !important"
  },

  [theme.breakpoints.down("sm")]: {
    bottom:"10px",
    right: "20px",

    "&:before":{
      backgroundSize:"contain",
      height: "18px",
      minWidth:"18px"
    }
  }
}));

export const StyledButtonLink = styled(ButtonLink)(({ theme }) => ({
  minWidth:"unset",
  opacity: 0,
  pointerEvents: "none",
  color: theme.customColors.backgroundPrimaryCta,
  fontSize:"1.141rem",
  fontWeight:"400",
  gap:"9px",
  zIndex: "1",
  position:"absolute",
  border: `1px solid ${theme.customColors.backgroundPrimaryCta}`,
  backgroundColor: alpha(theme.customColors.textPrimaryCta, 0.8),
  "&.MuiButton-outlinedPrimary": {
    "&:hover": {
      "borderColor": theme.customColors.backgroundPrimaryCta
    }
  },

  left:"42px",
  top:"32px",

  ".icon":{
    height:"18px",
    width:"13px"
  },

  [theme.breakpoints.down("sm")]: {
    left: "20px",
    minWidth: "auto",
    top: "16px"
  }
}));
export const ButtonDigitedLink = styled(ButtonDigited)(({ theme }) => ({
  pointerEvents: "none",
  gap:"0.4rem",
  zIndex: "1",
  position:"absolute",
  left:"3rem",
  top:"1.5rem",
  [theme.breakpoints.down("sm")]: {
    left: "1.25rem",
    top: "1.5rem"
  }
}));

export const StyledIcon = styled(Icon)(({ theme }) => ({
  "path":{
    fill: theme.customColors.textPrimary
  }
}));

export const StyledCoverLoader = styled(Box)<
  BoxProps & {
    $cover?: string
    $videoVisible: boolean
  }
>(({
  theme,
  $cover,
  $videoVisible
}) => ({
  background: `${theme.linearGradients.gradientDAlternative01},
    ${theme.linearGradients.gradientDAlternative03}, url(${$cover})`,
  backgroundPosition: "center",
  backgroundRepeat:"no-repeat",
  backgroundSize: "cover",
  justifyContent:"flex-end",
  minHeight: "750px",
  overflow: "hidden",
  width: "100%",

  ">main":{
    pointerEvents:"none",
    zIndex: 1
  },

  "> main >span":{
    opacity:!$videoVisible ? 1 : 0,
    right:"42px"
  },

  [`${StyledButtonBookmark}, ${StyledButtonLink}, ${StyledStatusBoxPlayer}`]:{
    opacity: !$videoVisible ? 1 : 0,
    pointerEvents: !$videoVisible ? "auto" : "none"
  },

  [`${ButtonDigitedLink}`]: {
    opacity: !$videoVisible ? 1 : 0,
    pointerEvents: !$videoVisible ? "auto" : "none"
  },

  ".video-caption": {
    height: "fit-content",
    opacity: !$videoVisible ? 1 : 0,
    pointerEvents: "none"
  },

  ".icon-play":{
    alignItems:"center",
    backgroundColor: theme.customColors.backgroundPrimary,
    border:`1px solid ${theme.customColors.textPrimaryCta}`,
    borderRadius:"50%",
    cursor: "pointer",
    display:"flex",
    height:"70px",
    justifyContent: "center",
    margin:"auto",
    position:"absolute",
    width:"70px",

    bottom:0,
    left:0,
    right:0,
    top:0,

    "& path": {
      fill: theme.customColors.textPrimaryCta
    }
  },

  "&:hover":{
    [`${StyledButtonBookmark}, ${StyledButtonLink}, ${StyledStatusBoxPlayer}, > main >span, .video-caption `]:{
      opacity:1,
      pointerEvents:"auto",
      zIndex:theme.zIndex.drawer
    },
    [`${StyledButtonBookmark}, ${ButtonDigitedLink}, ${StyledStatusBoxPlayer}, > main >span, .video-caption `]:{
      opacity:1,
      display:"unset",
      pointerEvents:"auto",
      zIndex:theme.zIndex.drawer
    }
  },

  [theme.breakpoints.down("sm")]: {
    minHeight: "450px",

    [`${StyledButtonLink}`]:{
      fontSize: "0.75rem",

      [`${StyledIcon}`]:{
        height: "15px",
        width: "12px"
      }
    },
    [`${ButtonDigitedLink}`]:{
      fontSize: "0.75rem",

      [`${StyledIcon}`]:{
        height: "15px",
        width: "12px"
      }
    },

    ".video-caption":{
      "h3":{
        fontSize: "1rem"
      }
    }
  }
}));

export const StyledPlayerLoader = styled(PlayerLoader)<
  PlayerLoaderProps
>(({ theme, isMobile, isLandscape, isFullScreen }) => ({
  overflow: "hidden",
  position:"relative",

  "&::before":{
    backgroundImage: `${theme.linearGradients.gradientVideoPlayerLoader}`,
    content:"''",
    inset:0,
    opacity:1,
    position:"absolute",
    transition:"all .3s linear",
    zIndex:0
  },

  height: "100%",
  width: "100%",

  ">main >span":{
    right:"42px"
  },

  [`${StyledButtonBookmark}`]:{
    right:"85px"
  },

  ".video-caption": {
    height: "fit-content",
    pointerEvents: "none"
  },

  ".video-js": {
    display:"block",
    height: "100%",
    margin: "0 auto",
    maxWidth: "1440px",
    padding: "0",
    width: "100%",

    "video": {
      objectFit: "contain"
    },

    "span": {
      "&:before":{
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        position: "static"
      }
    },

    ".vjs-big-play-button": {
      alignItems: "center",
      backgroundColor: theme.customColors.backgroundPrimary,
      border: `1px solid ${theme.customColors.backgroundPrimary}`,
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",

      height: "70px",
      width: "70px",
      zIndex:1,

      "span":{
        "&:before":{
          //eslint-disable-next-line max-len
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='21' height='26' viewBox='0 0 21 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.09943 24.0796C3.44445 25.2429 1.16729 24.0421 1.17974 22.0157L1.24196 12.0212L1.24196 3.29003C1.24196 1.16353 3.74309 0.000217722 5.36074 1.38869L18.9614 10.345C20.2929 11.3832 20.2431 13.4096 18.8619 14.3728L9.15599 21.2151' stroke='%23${theme.customColors.backgroundPrimaryCta.replace("#", "")}' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");`,
          color: theme.customColors.textPrimaryCta,
          content: " '' !important ",
          display: "flex",
          position: "static",

          height: "24px",
          width: "18px"
        },
        height: "24px",
        width: "18px"
      }

    },

    ".vjs-control-bar": {
      alignItems: "center",
      background: `${(isMobile || isFullScreen) ? `linear-gradient(0deg, rgba(${theme.customColors.gradient02Start}) 10%,
   rgba(${theme.customColors.gradient02End}) 100%), linear-gradient(180deg, rgba(${theme.customColors.gradient02Start}) 10%,
   rgba(${theme.customColors.gradient02End}) 100%)` : "transparent"}`,
      bottom: `${(isLandscape && isFullScreen) ? "10px" : "40px"}`,
      flexWrap: "wrap",
      height: "5rem",
      margin: "0 auto ",
      width: "95%",
      maxWidth: "1440px",
      padding: `${(isFullScreen) ? "20px 42px 0px 42px" : "0 42px"}`,
      transform: "translateY(0) !important",
      borderRadius: `${(isFullScreen) ? "10px" : "0"}`,
      zIndex: "2 !important",

      ".vjs-playback-rate, .vjs-subs-caps-button":{
        right: (isFullScreen ? "0" : "45px"),
        ">.vjs-menu":{
          ".vjs-menu-content":{
            backgroundColor: alpha(theme.customColors.backgroundPrimaryCta,0.3),
            borderRadius:"0.24rem",

            ".vjs-menu-item":{
              backgroundColor:alpha(theme.customColors.backgroundPrimaryLighter,0.7),
              color: theme.customColors.systemPrimary01,

              "&:hover":{
                // eslint-disable-next-line max-len
                textShadow:`0 0 1em ${theme.customColors.backgroundPrimaryCta}, 0 0 1em ${theme.customColors.backgroundPrimaryCta}, 0 0 1em ${theme.customColors.backgroundPrimaryCta}`
              },

              "&.vjs-selected":{
                backgroundColor:theme.customColors.backgroundPrimaryCta,
                color:theme.customColors.textPrimaryAlternative
              }
            }
          }
        },
        [theme.breakpoints.down("sm")]: {
          right: (isFullScreen ? "0" : "35px")
        }
      },


      ".vjs-playback-rate":{
        color: theme.customColors.textPrimary,
        height:"40px",
        width:"30px",

        ".vjs-playback-rate-value":{
          height:"fit-content",
          margin:"auto",

          bottom:0,
          rigth:0
        }
      },

      ".vjs-current-time ": {
        marginLeft: "8px"
      },
      ".vjs-current-time, .vjs-duration, .vjs-time-divider ": {
        fontSize: "1rem",
        margin: "0",
        padding: "0",

        "span":{
          color:theme.customColors.textPrimary
        }
      },
      ".vjs-fullscreen-control": {
        right: (isFullScreen ? "0" : "45px"),
        order: "9999",
        "span":{
          "&:before":{
            //eslint-disable-next-line max-len
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.45921 1H4.22392C2.67098 1 1.40039 2.27059 1.40039 3.82353V8.05882' stroke='%23${theme.customColors.textPrimary.replace("#", "")}' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M25.4006 8.05882V3.82353C25.4006 2.27059 24.13 1 22.5771 1H18.3418' stroke='%23${theme.customColors.textPrimary.replace("#", "")}' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M18.3418 25.0002H22.5771C24.13 25.0002 25.4006 23.7296 25.4006 22.1767V17.9414' stroke='%23${theme.customColors.textPrimary.replace("#", "")}' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M1.40039 17.9414V22.1767C1.40039 23.7296 2.67098 25.0002 4.22392 25.0002H8.45921' stroke='%23${theme.customColors.textPrimary.replace("#", "")}' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");`
          }
        },
        [theme.breakpoints.down("sm")]: {
          right: (isFullScreen ? "0" : "35px")
        }
      },
      ".vjs-picture-in-picture-control": {
        display: "none"
      },
      ".vjs-play-control": {
        "span":{

          "&:before": {
            // eslint-disable-next-line max-len
            backgroundImage:`url("data:image/svg+xml,%3Csvg width='16' height='20' viewBox='0 0 16 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.52355 20H2.49543C1.11795 20 0 18.88 0 17.5V2.50001C0 2.13001 0.0798538 1.77001 0.239561 1.43001C0.359342 1.18001 0.658794 1.08001 0.908337 1.19001C1.15788 1.31001 1.26768 1.61001 1.1479 1.86001C1.04808 2.06001 1.00815 2.28001 1.00815 2.50001V17.5C1.00815 18.33 1.67693 19 2.50541 19H3.53353C4.36201 19 5.03079 18.33 5.03079 17.5V2.50001C5.03079 1.79001 4.52172 1.17001 3.823 1.03001C3.55349 0.980014 3.37382 0.710014 3.43371 0.440014C3.48362 0.170014 3.74315 -0.00998624 4.02263 0.0500138C5.1905 0.280014 6.03894 1.31001 6.03894 2.50001V17.5C6.03894 18.88 4.92099 20 3.54351 20H3.52355Z' fill='%23${theme.customColors.textPrimary.replace("#", "")}'/%3E%3Cpath d='M12.5071 20C11.1297 20 10.0117 18.88 10.0117 17.5V2.5C10.0117 1.12 11.1297 0 12.5071 0H13.5053C14.8828 0 16.0008 1.12 16.0008 2.5V16.8C16.0008 17.08 15.7812 17.3 15.5017 17.3C15.2222 17.3 15.0026 17.08 15.0026 16.8V2.5C15.0026 1.67 14.3338 1 13.5053 1H12.5071C11.6787 1 11.0099 1.67 11.0099 2.5V17.5C11.0099 18.33 11.6787 19 12.5071 19H13.156L13.5452 18.95C13.8148 18.91 14.0643 19.11 14.1042 19.38C14.1342 19.65 13.9445 19.9 13.675 19.94L13.2258 20H12.5171H12.5071Z' fill='%23${theme.customColors.textPrimary.replace("#", "")}'/%3E%3C/svg%3E");`
          }
        },

        "&.vjs-paused":{
          "span":{
            "&:before":{
              //eslint-disable-next-line max-len
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='21' height='26' viewBox='0 0 21 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.09943 24.0796C3.44445 25.2429 1.16729 24.0421 1.17974 22.0157L1.24196 12.0212L1.24196 3.29003C1.24196 1.16353 3.74309 0.000217722 5.36074 1.38869L18.9614 10.345C20.2929 11.3832 20.2431 13.4096 18.8619 14.3728L9.15599 21.2151' stroke='%23${theme.customColors.textPrimary.replace("#", "")}' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");`
            }
          }
        }
      },



      ".vjs-progress-control": {
        margin: "0",
        order: "0",
        width: "100%",
        height: "7px!important",

        maxWidth: `${(!isMobile && isFullScreen) ? "100%" : "1440px"}`,
        padding:"0 42px",
        top: `${(!isMobile && isFullScreen) ? "15px !important" : "0 !important"}`,


        ".vjs-load-progress":{
          borderRadius: "40px",

          ">div": {
            background: alpha(theme.customColors.textWidget,0.4),
            borderRadius: "40px"
          }
        },

        ":hover .vjs-progress-holder": {
          height: "7px",
          fontSize: "inherit"
        },

        // "&:hover ": {

        //   ".vjs-progress-holder .vjs-play-progress": {
        //     "&:before": {
        //       bottom: "-0.9em",
        //       height: "30px",
        //       width: "30px"
        //     }
        //   }

        // },

        ".vjs-play-progress": {
          backgroundColor: theme.customColors.accentVariantB,
          borderRadius: "40px",
          position: "relative",

          "&:before": {
            backgroundColor: theme.customColors.accentVariantB,
            border: `2px solid ${theme.customColors.borderTag}`,
            borderRadius: "40px",
            bottom: "-6px",
            content: "''",
            display: "flex",
            height: "24px",
            width: "24px",
            zIndex:0,

            position: "absolute"
          }

        },

        ".vjs-progress-holder": {
          backgroundColor: alpha(theme.customColors.textWidget,0.4),
          borderRadius: "40px",
          height: "7px",
          margin: "0"
        },

        ".vjs-time-tooltip": {
          top: "-5.4em"
        }
      },
      ".vjs-subs-caps-button": {
        alignItems: "center",
        cursor: "pointer",
        display: "flex !important",
        order: "9999",
        padding: "0",

        ">span": {
          "&:before": {
            //eslint-disable-next-line max-len
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='32' height='30' viewBox='0 0 32 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M31.4 18.6V4.2C31.4 2.44 29.96 1 28.2 1H4.2C2.44 1 1 2.44 1 4.2V21.8C1 23.56 2.44 25 4.2 25H28.152C28.712 25 29.256 24.856 29.736 24.584L31.4 23.64' stroke='%23${theme.customColors.textPrimary.replace("#", "")}' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M5.7998 15.4004H20.1998' stroke='%23${theme.customColors.textPrimary.replace("#", "")}' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M23.3994 15.4004H26.5994' stroke='%23${theme.customColors.textPrimary.replace("#", "")}' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M5.7998 18.5996H8.9998' stroke='%23${theme.customColors.textPrimary.replace("#", "")}' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12.2002 18.5996H26.6002' stroke='%23${theme.customColors.textPrimary.replace("#", "")}' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");`
          }
        },

        ".vjs-menu ":{
          ".vjs-menu-content":{
            bottom: "3.5em",
            zIndex: 4,

            // hide captions setting button
            ".vjs-texttrack-settings":{
              display:"none"
            }
          }
        }
      },
      ".vjs-time-divider ": {
        minWidth: "unset",
        width: "10px"
      },
      ".vjs-volume-panel ": {
        marginRight: "0",


        ".vjs-mute-control":{

          height:"fit-content",

          "span":{
            "&:before":{
              //eslint-disable-next-line max-len
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='18' viewBox='0 0 24 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.2998 1.94531C11.7358 1.62109 11.0638 1.62109 10.4998 1.94531L6.77987 4.09474C6.49187 4.26285 6.15588 4.34691 5.81989 4.34691H3.13194C1.40397 4.34691 0 5.75184 0 7.48099V10.0267C0 11.7558 1.40397 13.1608 3.13194 13.1608H5.80789C6.15588 13.1608 6.49187 13.2568 6.79187 13.4249L9.89981 15.1901C10.3558 15.4543 10.8718 15.5864 11.3878 15.5864C11.9038 15.5864 12.4438 15.4423 12.9117 15.1661C13.1997 14.998 13.2957 14.6257 13.1277 14.3376C12.9597 14.0494 12.5878 13.9653 12.3118 14.1214C11.7598 14.4456 11.0638 14.4576 10.4998 14.1334L7.39186 12.3682C6.91186 12.0921 6.37188 11.948 5.81989 11.948H3.14394C2.07596 11.948 1.21198 11.0834 1.21198 10.0147V7.46899C1.21198 6.40027 2.07596 5.5357 3.14394 5.5357H5.83189C6.38388 5.5357 6.92386 5.3916 7.39186 5.11542L11.1118 2.96599C11.3758 2.80989 11.6158 2.91796 11.7118 2.96599C11.8078 3.01402 12.0118 3.17013 12.0118 3.48233V11.7198C12.0118 12.056 12.2758 12.3202 12.6118 12.3202C12.9477 12.3202 13.2117 12.056 13.2117 11.7198V3.50635C13.2117 2.85792 12.8757 2.26953 12.3118 1.94531H12.2998Z' fill='%23${theme.customColors.textPrimary.replace("#", "")}'/%3E%3Cpath d='M16.2354 3.65082C16.0075 3.89098 16.0075 4.26323 16.2354 4.50339C17.3754 5.63214 17.9994 7.14515 17.9994 8.75422C17.9994 10.3633 17.3994 11.8042 16.3194 12.921C16.0915 13.1612 16.0915 13.5454 16.3314 13.7736C16.4514 13.8816 16.5954 13.9417 16.7514 13.9417C16.9074 13.9417 17.0634 13.8816 17.1834 13.7616C18.4914 12.4167 19.2114 10.6275 19.2114 8.75422C19.2114 6.88097 18.4674 5.01973 17.0994 3.65082C16.8594 3.41066 16.4874 3.41066 16.2474 3.65082H16.2354Z' fill='%23${theme.customColors.textPrimary.replace("#", "")}'/%3E%3Cpath d='M19.5609 0.168112C19.3209 0.408272 19.3209 0.780519 19.5609 1.02068C21.6488 3.11007 22.8008 5.88391 22.8008 8.82587C22.8008 11.7678 21.6968 14.4216 19.7049 16.499C19.4769 16.7391 19.4769 17.1234 19.7169 17.3515C19.8369 17.4596 19.9808 17.5197 20.1368 17.5197C20.2928 17.5197 20.4488 17.4596 20.5688 17.3395C22.7888 15.046 24.0008 12.032 24.0008 8.83788C24.0008 5.64375 22.7288 2.48565 20.4128 0.18012C20.1728 -0.0600399 19.8009 -0.0600399 19.5609 0.18012V0.168112Z' fill='%23${theme.customColors.textPrimary.replace("#", "")}'/%3E%3C/svg%3E");`,
              backgroundPosition:"center"
            }

          },

          "&.vjs-vol-0":{
            "span":{
              "&:before":{
                //eslint-disable-next-line max-len
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='18' viewBox='0 0 24 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.18023 4.07626L11.0686 2.98202C11.3435 2.8257 11.5706 2.93392 11.6662 2.98202C11.7618 3.03012 11.965 3.18644 11.965 3.49908V6.33688C11.965 6.67357 12.228 6.93811 12.5626 6.93811C12.8973 6.93811 13.1602 6.67357 13.1602 6.33688V3.49908C13.1602 2.84975 12.8256 2.26054 12.2638 1.93588C11.7021 1.61122 11.0328 1.61122 10.471 1.93588L8.58263 3.03012C8.29578 3.19846 8.20016 3.5592 8.36749 3.84779C8.53482 4.13638 8.89338 4.23258 9.18023 4.06423V4.07626Z' fill='%23${theme.customColors.textPrimary.replace("#", "")}'/%3E%3Cpath d='M17.9421 8.75371C17.9421 9.29482 17.8704 9.8239 17.7389 10.341C17.6552 10.6656 17.8345 10.9903 18.1572 11.0745C18.205 11.0865 18.2648 11.0985 18.3126 11.0985C18.5755 11.0985 18.8146 10.9181 18.8863 10.6536C19.0536 10.0403 19.1373 9.40304 19.1373 8.75371C19.1373 6.82978 18.3963 5.01406 17.0337 3.64326C16.7947 3.40277 16.4242 3.40277 16.1851 3.64326C15.9461 3.88375 15.9461 4.25651 16.1851 4.49701C17.3206 5.62732 17.9421 7.14242 17.9421 8.75371Z' fill='%23${theme.customColors.textPrimary.replace("#", "")}'/%3E%3Cpath d='M22.7208 8.83807C22.7208 10.3411 22.422 11.7961 21.8483 13.1549C21.7168 13.4555 21.8602 13.8163 22.159 13.9485C22.2307 13.9846 22.3144 13.9966 22.3981 13.9966C22.6251 13.9966 22.8522 13.8644 22.9478 13.6359C23.5933 12.1208 23.916 10.5095 23.916 8.8501C23.916 5.57941 22.649 2.48909 20.3423 0.180369C20.1033 -0.060123 19.7328 -0.060123 19.4937 0.180369C19.2547 0.420861 19.2547 0.793623 19.4937 1.03411C21.5734 3.12639 22.7208 5.90407 22.7208 8.8501V8.83807Z' fill='%23${theme.customColors.textPrimary.replace("#", "")}'/%3E%3Cpath d='M23.7366 16.5696L0.956156 0.444636C0.693213 0.252242 0.310751 0.32439 0.11952 0.588931C-0.0717117 0.865496 0 1.23826 0.262943 1.43065L4.39832 4.35263H3.11946C1.39838 4.35263 0 5.7595 0 7.49105V10.0403C0 11.7718 1.39838 13.1787 3.11946 13.1787H5.78475C6.13135 13.1787 6.46601 13.2749 6.76481 13.4432L9.86036 15.2108C10.3145 15.4754 10.8285 15.6076 11.3424 15.6076C11.8563 15.6076 12.3942 15.4634 12.8603 15.1868C13.1472 15.0184 13.2428 14.6457 13.0754 14.3571C12.9081 14.0685 12.5376 13.9723 12.2508 14.1406C11.701 14.4773 11.0078 14.4773 10.458 14.1527L7.3624 12.3851C6.88433 12.1085 6.34649 11.9642 5.7967 11.9642H3.13141C2.06769 11.9642 1.20715 11.0984 1.20715 10.0282V7.47902C1.20715 6.40883 2.06769 5.54306 3.13141 5.54306H5.80865C5.89231 5.54306 5.96403 5.53104 6.03574 5.49496L11.9639 9.69155V11.7478C11.9639 12.0844 12.2269 12.349 12.5615 12.349C12.8962 12.349 13.1591 12.0844 13.1591 11.7478V10.5333L23.0553 17.5316C23.1629 17.6037 23.2824 17.6398 23.4019 17.6398C23.5932 17.6398 23.7724 17.5556 23.892 17.3873C24.0832 17.1107 24.0115 16.738 23.7485 16.5456L23.7366 16.5696Z' fill='%23${theme.customColors.textPrimary.replace("#", "")}'/%3E%3C/svg%3E");`
              }
            }
          }


        },

        ".vjs-volume-control":{
          borderRadius: "4px",
          height: "5px",
          ".vjs-volume-bar":{
            backgroundColor: alpha(theme.customColors.textWidget,0.4)
          },

          ".vjs-volume-bar.vjs-slider-horizontal":{
            borderRadius: "4px",
            height: "5px"
          }
        },

        ".vjs-volume-level": {
          backgroundColor: theme.customColors.accentVariantB,
          borderRadius: "4px",
          height: "5px"
        }
      },
      ".vjs-volume-panel .vjs-button, .vjs-play-control, .vjs-fullscreen-control, .vjs-subs-caps-button": {
        outline: "none",
        "&:hover": {
          transform: "scale(1.2)"
        },
        "> span":{
          "&:before":{
            content: "'' !important",
            display: "flex",
            height: "24px",
            width: "24px"
          },
          height: "24px",
          width: "24px"
        },
        transition: "all .3s ease"
      },
      "> div, > button": {
        alignItems: "center",
        margin: "0 0.5rem",
        order: "1",
        width: "fit-content"
      }
    },

    ".vjs-poster": {
      "img": {
        objectFit: "cover"
      }
    },

    "picture.vjs-poster::after": {
      content: "\"\"",
      position: "absolute",
      inset: 0,
      background: theme.linearGradients.gradientC,
      zIndex: 1,
      pointerEvents: "none"
    },

    ".vjs-title-bar": {
      display: "none"
    }
  },

  "> div": {
    height: "100%"
  },
  ">main":{
    pointerEvents:"none",
    zIndex: 1
  },

  [` >main >span, .video-caption, ${StyledButtonBookmark}, ${StyledStatusBoxPlayer}`]: {
    opacity: 0,
    pointerEvents: "none",
    transition: "all .3s linear"
  },

  "&.brightcove-is-paused": {
    [`>main >span, ${ButtonDigitedLink}, ${StyledButtonLink}, ${StyledButtonBookmark}`]: {
      pointerEvents: "auto"
    },
    [`>main >span, .video-caption,
    ${ButtonDigitedLink}`]:{
      display:"flex"
    },
    [`>main >span, .video-caption,
    ${StyledButtonLink},
    ${StyledButtonBookmark},
    ${StyledButtonBookmark},
    ${StyledStatusBoxPlayer}`]: {
      opacity: 1
    },
    [`${ButtonDigitedLink}`]: {
      opacity: "1 !important",
      pointerEvents: "auto"
    },
    "&::before":{
      opacity:1,
      zIndex:1
    }
  },

  "&.brightcove-is-playing":{

    ".vjs-big-play-button": {
      display: "none"
    },

    ".vjs-control-bar": {
      opacity: "0 !important"
    },

    "&::before":{
      opacity:0,
      zIndex:0
    },

    [`${ButtonDigitedLink}`]: {
      opacity: 0,
      pointerEvents: "none"
    },

    "&:hover":{
      [` ${StyledButtonBookmark}, ${StyledStatusBoxPlayer}, .vjs-control-bar`]: {
        opacity: "1 !important",
        pointerEvents: "auto"
      },

      "&::before":{
        opacity:1,
        zIndex:1
      }
    }


  },

  "&.canPlayBack":{

    [`${StyledButtonBookmark}`]:{
      right:"85px",

      [theme.breakpoints.down("md")]: {
        right: "70px"
      }
    },
    ".video-js": {

      ".vjs-control-bar": {
        ".vjs-progress-control":{
          opacity:0.5,
          pointerEvents:"none"
        },

        ".vjs-playback-rate":{
          display:"none"
        }

      }
    }
  },

  "&:hover": {
    [`> main >span,  ${ButtonDigitedLink}, ${StyledButtonLink}`]: {
      pointerEvents: "auto"
    },
    [`> main >span, .video-caption, ${ButtonDigitedLink}, ${StyledButtonLink}, ${StyledStatusBoxPlayer}`]: {
      opacity: 1
    }
  },
  [theme.breakpoints.down("lg")]: {
    ".video-caption":{
      paddingBottom: "30px !important"
    }

  },

  [theme.breakpoints.up(1920)]: {
    ".vjs-text-track-cue": {
      inset: `${isLandscape && isFullScreen ? "75vh 0px 0px !important" : "inherit"}`
    }
  },

  [theme.breakpoints.down(1200)]: {
    ".vjs-text-track-cue": {
      inset: `${isLandscape && isFullScreen ? "65vh 0px 0px !important" : "inherit"}`
    }
  },

  [theme.breakpoints.down("sm")]: {

    [`${StyledButtonLink}, ${ButtonDigitedLink}`]:{
      fontSize: "0.5rem",

      [`${StyledIcon}`]:{
        height: "15px",
        width: "12px"
      }
    },
    [`${StyledButtonBookmark}`]:{
      right:"40px"
    },
    ".video-js":{
      position: "relative",

      "video":{
        position: "relative"
      },

      ".vjs-control-bar":{
        bottom: "0px",
        height: "3rem",
        padding:"0 20px",

        ".vjs-progress-control":{
          padding:"0 20px",
          top: "-1.8em"
        },

        ".vjs-playback-rate":{
          display:"flex !important",
          height: "18px",
          width: "18px",

          ">.vjs-menu":{
            ".vjs-menu-content":{
              bottom:"0px !important"
            }

          }
        },

        ".vjs-volume-panel .vjs-button, .vjs-play-control, .vjs-fullscreen-control, .vjs-subs-caps-button":{
          "> span":{
            "&:before":{
              height: "18px",
              width: "18px"
            },
            height: "18px",
            width: "18px"
          }
        }
      },

      ".vjs-big-play-button":{
        border: "none"
      }

    },

    ".video-caption":{

      paddingBottom: "25px !important",

      "h3":{
        fontSize: "0.75rem"
      }
    },

    "&.canPlayBack":{
      ".video-js": {
        ".vjs-control-bar": {
          ".vjs-playback-rate":{
            display:"none !important"
          }
        }
      },


      [`${StyledButtonBookmark}`]:{
        right:"85px"
      },

      [theme.breakpoints.down("sm")]: {
        [`${StyledButtonBookmark}`]:{
          right:"35px"
        }
      }
    }
  }
}));

export const StyledStatusBoxPlayer = styled(Box)<BoxProps>(({ theme }) => ({

  [`${StyledStatusBox}`]:{
    left: "0px",
    marginBottom: "42px",
    top: "16%",
    zIndex: theme.zIndex.appBar,

    height: "60px",
    width: "60px",

    "svg":{
      height:"30px !important",
      width:"30px !important"
    },

    [theme.breakpoints.down("sm")]: {
      height: "40px",
      top:"20%",
      width: "40px",

      [`${StyledIcon}`]:{
        height: "24px",
        width: "24px"
      }
    }
  }

}));

export const VideoStack = styled(Stack)<{$isExternal: boolean}>(({ theme, $isExternal }) => ({
  background: theme.palette.background?.paper,
  minHeight: $isExternal ? "750px" : "100%",

  [theme.breakpoints.down("sm")]:{

    height: $isExternal ? "450px" : "100%",
    minHeight:$isExternal ? "450px" : "100%",

    [`${OverlayStack}`]: {
      display: "none"
    }
  }
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: "3rem",
  lineHeight: 7 / 6,
  textShadow: `0 0 1.25rem ${alpha(theme.palette.background?.paper ?? common["black"], 0.25)}`
}));

export const StyledScormPlayButton = styled(Box)(({ theme }) => ({
  alignItems: "center",
  backgroundColor: theme.customColors.backgroundPrimary,
  border: `1px solid ${theme.customColors.backgroundPrimary}`,
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",

  height: "70px",
  width: "70px",
  zIndex:1,

  "span":{
    "&:before":{
      //eslint-disable-next-line max-len
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='21' height='26' viewBox='0 0 21 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.09943 24.0796C3.44445 25.2429 1.16729 24.0421 1.17974 22.0157L1.24196 12.0212L1.24196 3.29003C1.24196 1.16353 3.74309 0.000217722 5.36074 1.38869L18.9614 10.345C20.2929 11.3832 20.2431 13.4096 18.8619 14.3728L9.15599 21.2151' stroke='%23${theme.customColors.backgroundPrimaryCta.replace("#", "")}' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");`,
      color: theme.customColors.backgroundPrimaryCta,
      content: " '' !important ",
      display: "flex",
      position: "static",

      height: "26px",
      width: "21px"
    },
    height: "26px",
    width: "21px"
  }
}));


